import qs from "qs";
import { useCallback } from "react";
import { Navigate } from "react-router";
import { ssoApi } from "@entrilia/shared/api/sso";
import { getAuthSettings } from "@entrilia/shared/auth/settings";
import FullScreenLoader from "@entrilia/shared/components/fullScreenLoader/FullScreenLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import { pageRoutes } from "../routes";

const redirect = (redirectToLogoutUrl: string) => {
  const query = qs.stringify({
    post_logout_redirect_uri: `${window.location.origin}/${pageRoutes.loggedOut}`,
  });
  window.location.href = `${redirectToLogoutUrl}?${query}`;
};

const Logout = () => {
  const logout = useCallback(() => {
    const { userFlowSignIn, cookieTarget } = getAuthSettings();
    return ssoApi.logout({ userFlow: userFlowSignIn, cookieTarget });
  }, []);

  const [logoutResp, error] = useFetch(logout);

  if (error) {
    logError(error, "[Logout] logout");
    return <Navigate to={`/${pageRoutes.error}`} />;
  }

  if (logoutResp) {
    redirect(logoutResp.redirectToLogoutUrl);
    return null;
  }

  return <FullScreenLoader title="Please wait." subtitle="We're logging you out..." />;
};

export default Logout;
